import axios from 'axios'
import router from '../router/index'
import { Toast } from 'vant';


const service = axios.create({
  baseURL: process.env.NODE_ENV === 'production' ? process.env.VUE_APP_BASE_API : '/', // api 的 base_url
  timeout: 30000// 请求超时时间
})
service.defaults.baseURL = process.env.VUE_APP_API; // 测试 生产
// axios.defaults.baseURL = ''; // 测试 生产
// axios.defaults.baseURL = ""; // 本地


//请求拦截
service.interceptors.request.use(function (config) {
  // Do something before request is sent
  let token = window.localStorage.getItem("openid") ? window.localStorage.getItem("openid") : window.localStorage.getItem("openidC")
  let agentPhone=window.localStorage.getItem('phone') ? window.localStorage.getItem('agentPhone') : window.localStorage.getItem('phoneNo') 
  if (token) {
    config.headers['izf'] = token    //将token放到请求头发送给服务器
  }
  if(agentPhone){
    config.headers['agentPhone'] = agentPhone
  }
  return config;
}, function (error) {
  // Do something with request error
  return Promise.reject(error);
});
//请求拦截
service.interceptors.response.use(function (config) {
  return config;
}, function (error) {
  if(error.message.indexOf('timeout')>=0){
    Toast("服务器正忙，稍后重试!!!")
  }
  // Do something with request error
  return Promise.reject(error);
});
////返回一个Promise(发送post请求)
export function fetchPost(url, params) {
  return new Promise((resolve, reject) => {
    service.post(url, params)
      .then(response => {
        if (response.data.code == '1111') {
          router.push('/login')
        }
        resolve(response);

      }, err => {
        reject(err);
      })
      .catch((error) => {
        reject(error)
      })
  })
}
////返回一个Promise(发送get请求)
export function fetchGet(url, param) {
  return new Promise((resolve, reject) => {
    service.get(url, { params: param })
      .then(response => {
        if (response.data.code == '1111') {
          router.push('/login')
        }
        resolve(response)

      }, err => {
        reject(err)
      })
      .catch((error) => {
        reject(error)
      })
  })
}
//对象转formdata格式
export function toFormData(config) { //对象转formdata格式
  const formData = new FormData();
  Object.keys(config).forEach((key) => {
    formData.append(key, config[key]);
  });
  return formData;
}

export default {
  fetchPost,
  fetchGet,
  toFormData
}
